"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var ContentContainer = function ContentContainer(props) {
  var componentStyle = {
    maxWidth: props.width + 'em',
    margin: '0 auto'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ContentContainer",
    style: componentStyle
  }, props.children);
};
ContentContainer.defaultProps = {
  width: 75
};
var _default = ContentContainer;
exports["default"] = _default;